<dx-pie-chart
  class="pie-chart"
  type="doughnut"
  palette="Harmony Light"
  [dataSource]="managerChartData"
  [customizePoint]="customizeManagerChartPoint"
  [legend]="{
    visible: true,
    verticalAlignment: 'bottom',
    horizontalAlignment: 'center',
    customizeText: customizeChartLabelText
  }"
>
  <dxi-series argumentField="label" valueField="value"></dxi-series>
</dx-pie-chart>
